
export const eventEmitterAtomId = 'pageletComponent:eventEmitter';
